/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleNoteChange);
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: evt.target.value });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-note', CartNote);
}

/* AQUALIVIA checkout consent layout override - added 2026-08-03 */
(function () {
  var STYLE_ID = 'aq-consent-layout-style';

  function ensureAqConsentLayoutStyle() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.aq-consent {',
      '  max-width: none !important;',
      '  margin: 24px 0 22px !important;',
      '  padding: 22px 24px !important;',
      '  background: #FAFAFA !important;',
      '  border: 1px solid #EEEEEE !important;',
      '  border-radius: 6px !important;',
      '  box-sizing: border-box !important;',
      '  color: #334e68 !important;',
      '}',
      '.aq-consent label {',
      '  margin: 0 0 16px !important;',
      '  gap: 12px !important;',
      '  align-items: flex-start !important;',
      '}',
      '.aq-consent label:last-child {',
      '  margin-bottom: 0 !important;',
      '}',
      '.aq-consent input {',
      '  margin-top: 5px !important;',
      '}',
      '.aq-consent small {',
      '  margin-top: 4px !important;',
      '  line-height: 1.55 !important;',
      '}',
      '.aq-consent .aq-error {',
      '  margin: 0 0 12px 30px !important;',
      '}',
      '@media (max-width: 749px) {',
      '  .aq-consent {',
      '    margin: 20px 0 18px !important;',
      '    padding: 18px 16px !important;',
      '  }',
      '  .aq-consent label {',
      '    gap: 10px !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureAqConsentLayoutStyle);
  } else {
    ensureAqConsentLayoutStyle();
  }

  document.addEventListener('on:line-item:change', ensureAqConsentLayoutStyle);
}());
